const STEP_STATUS = {
  ACCEPTED: 'accepted',
  STARTED: 'started',
  NEEDS_REVISION: 'needs_revision',
  NOT_STARTED: 'not_started',
  REVIEW_IN_PROCESS: 'review_in_process',
};

const SIGNATURE_STATUS = {
  PENDING: 'pending',
  REQUIRED: 'required',
  SIGNED: 'signed',
  WET_SIGNED: 'wet_signed',
  DECLINED: 'declined',
  CANCELLED: 'cancelled',
};

const USER_SETTING_VALUE_CPF_AM_SUPER_USER = 'cpf-am-super-user';
const USER_SETTING_VALUE_CPF_AM_TEAM_LEAD = 'cpf-am-team-lead';
const USER_SETTING_VALUE_CPF_CREDIT_ANALYST = 'cpf-credit-analyst';

const USER_TYPE_A = 'A';
const USER_TYPE_CPF = 'CPF';

const STEP_EXTERNAL_SKU_CAC = 'CAC';
const STEP_EXTERNAL_SKU_IC = 'IC';

const PRODUCT_TYPE_CASH = 'cash';
const PRODUCT_TYPE_PACE = 'pace';
const PRODUCT_TYPE_LOAN = 'loan';
const PRODUCT_TYPE_HVAC = 'hvac';
const PRODUCT_TYPE_BATTERY = 'battery';
const PRODUCT_TYPE_PPA = 'ppa';
const PRODUCT_TYPE_LEASE = 'lease';
const PRODUCT_TYPE_UFO = 'ufo';
const PRODUCT_TYPE_EE_PACE = 'epace';
const PRODUCT_TYPE_PREPAID = 'prepaid';
const PRODUCT_TYPE_EE_LOAN = 'eloan';
const PRODUCT_TYPE_COMMUNITY_SOLAR = 'community_solar';

const constants = {
  prescreen: {
    PREAPPROVED: 'PREAPPROVED',
    NOTPREAPPROVED: 'NOTPREAPPROVED',
    INFO_NEEDED: 'INFO_NEEDED',
    ERROR: 'ERROR',
    DISABLED: 'DISABLED',
  },

  SUPPORT_EMAIL: 'support@concertfin.com',
  PARTNER_SUPPORT_EMAIL: 'support@concertfin.com',
  GENERAL_SUPPORT_PHONE: '8559254890',
  UW_SUPPORT_PHONE: '8559254890',

  TITLE_STATUS_REJECT: 'reject',
  TITLE_STATUS_INITIATED: 'initiated',
  TITLE_STATUS_NEEDS_REVIEW: 'needs_review',
  TITLE_STATUS_CONDITIONAL_APPROVE: 'conditional_approve',
  TITLE_STATUS_FAST_APPROVE: 'fast_approve',
  TITLE_STATUS_FAIL_TEXT: 'Failed',
  TITLE_STATUS_FAST_APPROVE_TEXT: 'Approved',
  TITLE_STATUS_NEEDS_REVIEW_TEXT: 'Needs Review',
  TITLE_STATUS_CONDITIONAL_APPROVE_TEXT: 'Additional Documents Required',
  TITLE_STATUS_INITIATED_TEXT: 'Title is Pended',
  TITLE_STATUS_UNKNOWN_TEXT: 'Unable to Retrieve Title Information',

  PRODUCT_TYPE_CASH,
  PRODUCT_TYPE_PACE,
  PRODUCT_TYPE_LOAN,
  PRODUCT_TYPE_HVAC,
  PRODUCT_TYPE_BATTERY,
  PRODUCT_TYPE_PPA,
  PRODUCT_TYPE_LEASE,
  PRODUCT_TYPE_UFO,
  PRODUCT_TYPE_EE_PACE,
  PRODUCT_TYPE_PREPAID,
  PRODUCT_TYPE_COMMUNITY_SOLAR,
  PRODUCT_TYPE_EE_LOAN,

  PRODUCT_TYPES_TITLE_DOES_NOT_APPLY: [PRODUCT_TYPE_EE_LOAN, PRODUCT_TYPE_COMMUNITY_SOLAR],

  PRESCREEN_STATUS_PREAPPROVED: 'PREAPPROVED',
  PRESCREEN_STATUS_NOTPREAPPROVED: 'NOTPREAPPROVED',

  PRODUCT_STATUS_PASS: 'Pass',
  PRODUCT_STATUS_FAIL: 'Fail',
  PRODUCT_STATUS_PENDED: 'Pended',
  PRODUCT_STATUS_NORESPONSE: 'NoResponse',

  PRODUCT_OVERALL_STATUS_PASS: 'approved',
  PRODUCT_OVERALL_STATUS_FAIL: 'failed',
  PRODUCT_OVERALL_STATUS_PENDED: 'pended',
  PRODUCT_OVERALL_STATUS_INITIATED: 'initiated',
  PRODUCT_OVERALL_STATUS_INCOMPLETE: 'incomplete',

  PROPERTY_RULE_FAIL: 'fail',
  PROPERTY_RULE_PASS: 'pass',

  CREDIT_TYPE_PAPER: 'Paper',
  CREDIT_TYPE_EMAIL: 'Online',
  CREDIT_TYPE_PHONE: 'Phone',
  CREDIT_TYPE_IN_PERSON: 'Inperson',
  CREDIT_STATUS_DECISION_PENDING: 'Pending',
  CREDIT_STATUS_FAILED: 'Declined',
  CREDIT_STATUS_PASSED: 'Approved',
  CREDIT_STATUS_INITIATED: 'Initiated',

  DEFAULT_ADMIN_CUSTOMERS_FILTER: 'Received',

  FUNCTIONALITY_ACL_FEATURE_CODE_ADVANCED_CUSTOMERS_LIST: 'ADVANCED_CUSTOMERS_LIST',
  FUNCTIONALITY_ACL_FEATURE_CODE_SEND_HOMEOWNER_STIPS_EMAIL: 'SEND_HOMEOWNER_STIPS_EMAIL',
  FUNCTIONALITY_ACL_FEATURE_CODE_STEP4_ACCESS: 'STEP4_ACCESS',
  FUNCTIONALITY_ACL_FEATURE_CODE_QUICK_CHECK: 'QUICKCHECK',
  FUNCTIONALITY_ACL_FEATURE_CODE_HIDE_VALUE_PROPS: 'HIDE_VALUE_PROPS',
  FUNCTIONALITY_ACL_FEATURE_CODE_REQUEST_FUNDING: 'REQUEST_FUNDING',
  FUNCTIONALITY_ACL_FEATURE_CODE_ENHANCED_REMOTE_QUICK_CHECK: 'ENHANCED_REMOTE_QUICK_CHECK',
  FUNCTIONALITY_ACL_FEATURE_CODE_REPORTING_DISBURSEMENT: 'REPORTING_DISBURSEMENT',
  FUNCTIONALITY_ACL_PRODUCT_COMPARISON: 'PRODUCT_COMPARISON',
  FUNCTIONALITY_ACL_MANAGE_LICENSES: 'MANAGE_LICENSES',
  FUNCTIONALITY_ACL_MANAGE_TRAINING: 'MANAGE_TRAINING',
  FUNCTIONALITY_ACL_RETRIEVE_BORROWER_INFO: 'RETRIEVE_BORROWER_INFO',
  FUNCTIONALITY_ACL_EDIT_COMPANYADMIN: 'EDIT_COMPANYADMIN',
  FUNCTIONALITY_ACL_JOB_EXTENSION: 'JOB_EXTENSION',

  PRODUCT_ELEMENT_STEP4: 'step4',

  STIP_STATUS_ACCEPTED: 'Accepted',
  STIP_STATUS_REJECTED: 'Rejected',

  PRODUCTS_CAN_HAVE_STIPS: [PRODUCT_TYPE_LOAN, PRODUCT_TYPE_EE_LOAN, PRODUCT_TYPE_EE_PACE, PRODUCT_TYPE_PACE],

  STEP_EXTERNAL_SKU_CAC,
  STEP_EXTERNAL_SKU_IC,

  REQUIRED_PROPOSAL_MEASURES_FIELDS_BY_EXTERNAL_STEP_SKU: {
    [STEP_EXTERNAL_SKU_CAC]: ['category', 'measureId', 'estimatedCost', 'manufacturer', 'model', 'quantity'],
    [STEP_EXTERNAL_SKU_IC]: ['category', 'measureId', 'estimatedCost', 'manufacturer', 'model', 'quantity'],
  },

  STEP_DOC_PACKET_GROUP_NAME_HOMEOWNER: 'homeowner',
  STEP_DOC_PACKET_GROUP_NAME_HOMEOWNER_PACKET: 'homeowner_packet',
  STEP_DOC_PACKET_STATUS: { ACCEPTED: 'accepted' },

  VERIFIED_SIGNER_ROLE: { FINOPS: 'FinopsSigner' },

  STEP_DOC_PROJECT_INFO: 'ProjectInfo',

  STEP_DOCUMENT_TYPE: {
    ACCEPTANCE: 'acceptance',
    ADDITIONAL: 'additional',
    STANDARD: 'standard',
  },

  STEP_DOCUMENT_STATUS: {
    NEEDED: 'needed',
    UPLOADED: 'uploaded',
    ACCEPTED: 'accepted',
    NEEDS_REVISION: 'needs_revision',
    SUBMITTED: 'submitted',
    GENERATED: 'generated',
    READY_TO_BE_ISSUED: 'ready_to_be_issued',
    COMPLETE: 'complete',
  },

  STEP_DOC_EXTERNAL_SKU: {
    CompletionCertificateCSCDA: 'CompletionCertificateCSCDA',
    ExhibitACSCDA: 'ExhibitACSCDA',
    WELCOME_CALL: 'WelcomeCall',
  },

  STEP_STATUS,

  LOCKED_STEP_STATUSES: [STEP_STATUS.ACCEPTED, STEP_STATUS.REVIEW_IN_PROCESS],

  SIGNER_ROLES: {
    HOMEOWNER_PRIMARY_SIGNER: 'HomeownerPrimarySigner',
    HOMEOWNER_SECONDARY_SIGNER: 'HomeownerSecondarySigner',
    INSTALLER_SIGNER: 'InstallerSigner',
  },

  SIGNATURE_STATUS,

  SIGNED_SIGNATURE_STATUSES: [SIGNATURE_STATUS.SIGNED, SIGNATURE_STATUS.WET_SIGNED],

  VIRTUAL_SIGNER_ROLE_HOMEOWNER: 'homeowner',
  VIRTUAL_SIGNER_ROLE_INSTALLER: 'installer',

  SOLAR_MEASURES: [
    { id: 68, category: 'Solar', measure: 'Panel' },
    { id: 69, category: 'Solar', measure: 'Inverter' },
  ],

  ADD_EQUIPMENTS_FIELDS_PACE: [
    { name: 'System_Size_PACE', label: 'System Size (kW STC DC)', valueList: '' },
    {
      name: 'Monitoring_Type_PACE',
      label: 'Monitoring Type',
      valueList: { Internet: 'Internet', Cellular: 'Cellular' },
    },
  ],

  ADD_EQUIPMENTS_FIELDS_SLOAN: [
    { name: 'System_Size_SL', label: 'System Size (kW STC DC)', valueList: '' },
    { name: 'Monitoring_Type', label: 'Monitoring Type', valueList: { Internet: 'Internet', Cellular: 'Cellular' } },
  ],

  PACE_EQUIPMENT_ELEMENTS: ['System_Size_PACE', 'Monitoring_Type_PACE'],
  SLOAN_EQUIPMENT_ELEMENTS: ['System_Size_SL', 'Monitoring_Type'],

  ADMIN_STEP_DOC_STATUS: {
    NEW: 'new',
    ACCEPTED: 'accepted',
    REJECTED: 'rejected',
    ESCALATED: 'escalated',
    DELETED: 'deleted',
  },

  ADMIN_STEP_DOC_STATUS_DISPLAY: {
    NEW: 'NEW',
    ACCEPTED: 'Accepted',
    REJECTED: 'Rejected',
    ESCALATED: 'Escalated',
    DELETED: 'Deleted',
  },

  USER_TYPES: {
    USER_TYPE_A,
    USER_TYPE_CPF,
  },

  USER_SETTING_VALUES: {
    USER_SETTING_VALUE_CPF_AM_SUPER_USER,
    USER_SETTING_VALUE_CPF_AM_TEAM_LEAD,
    USER_SETTING_VALUE_CPF_CREDIT_ANALYST,
  },

  ADMIN_TIER: {
    ONE: 'tier_1',
    TWO: 'tier_2',
    ESCALATED: 'escalated',
  },

  TIER_STATUS: {
    ACCEPTED: 'accepted',
    ESCALATED: 'escalated',
    REJECTED: 'rejected',
    TIER_1_READY: 'tier_1_ready',
    TIER_2_READY: 'tier_2_ready',
  },

  ADMIN_STEP_STATUS: {
    TIER_1_STARTED: 'tier_1_started',
    TIER_1_READY: 'tier_1_ready',
    TIER_2_READY: 'tier_2_ready',
  },

  ADMIN_FINANCING_REQUEST_HISTORY_TYPES: {
    DOCUMENT_GENERATED: 'document_generated',
    DOCUMENT_UPLOADED: 'document_uploaded',
    DOCUMENT_UPLOADED_SPRUCE: 'document_uploaded_spruce',
    DOCUMENT_REJECTED: 'document_rejected',
    DOCUMENT_ACCEPTED: 'document_accepted',
    DOCUMENT_ESCALATED: 'document_escalated',
    DOCUMENT_DELETED: 'document_deleted',
    DOCUMENT_COMMENT_ADDED_INTERNAL: 'document_comment_added_internal',
    DOCUMENT_COMMENT_ADDED: 'document_comment_added',
    STEP_ACCEPTED: 'step_accepted',
  },

  ELEMENT_DISPLAY_TYPES: {
    INPUT_CHECKBOX: 'input_checkbox',
    INPUT_RADIO: 'input_radio',
    INPUT_TEXT: 'input_text',
    INPUT_TEXT_DATE: 'input_text_date',
    INPUT_TEXT_NUMBER: 'input_text_number',
    SELECT: 'select',
    TEXTAREA: 'textarea',
  },

  ERROR_CODE: {
    FORBIDDEN: 403,
  },

  SEND_FOR_SIGNATURE_MODE: {
    BY_EMAIL: 'by_email',
    IN_PERSON: 'in_person',
  },

  ELEMENT_SET_IDS: {
    PROJECT_INFO: 82,
  },

  MAX_SOLAR_AVAILABILITY: 100,
  MAX_AZIMUTH: 359,
  MAX_PITCH: 90,
  MAX_NUM_OF_MODULES: 200,
  MAX_NUM_OF_INVERTERS: 200,
  MIN_NUM_OF_INVERTERS: 0,

  EARLIEST_ALLOWABLE_PROJECT_INFO_DATE: '1899-12-31',
  EARLIEST_ALLOWABLE_DISBURSEMENT_REPORT_DATE: '2014-12-31',
  DISPLAY_DATE_FORMAT: 'MM-DD-YYYY',

  SERVICE_ADDRESS_TYPES: {
    RESIDENTIAL: 'residential',
    NON_RESIDENTIAL: 'non_residential',
  },

  SUBSCRIPTION_SIZING_METHOD: {
    USAGE: 'usage',
    COST: 'cost',
  },

  MSG_FUNDING_CONTACT: 'Please contact your company admin to request permission to manage this funding request.',

  MAX_LOAN_AMOUNT: 135000.0,

  LENDERS: [
    { productSku: 'SLOAN_MEDALLION_001', label: 'Solar+', isTestOnly: false },
    { productSku: 'CASH_005', label: 'Cash', isTestOnly: false },
    { productSku: 'SLOAN_TRIBEAM_001', label: 'TriBeam', isTestOnly: true },
    { productSku: 'SLOAN_EVERBRIGHT', label: 'EverBright', isTestOnly: true },
    { productSku: 'SLOAN_CLASSIC', label: 'Enerbank', isTestOnly: true },
    { productSku: 'SLOAN_MOSAIC', label: 'QAA Mosaic', isTestOnly: true },
    { productSku: 'SLOAN_003', label: 'Mosaic', isTestOnly: true },
    { productSku: 'HVAC_001', label: 'HVAC', isTestOnly: false, dependency: ['SLOAN_MEDALLION_001'] },
    { productSku: 'BATTERY_001', label: 'Battery', isTestOnly: false, dependency: ['SLOAN_MEDALLION_001'] },
  ],

  LENDER_PREFIX: [
    { code: 'cash', prefix: 'C' },
    { code: 'enerbank', prefix: 'E' },
    { code: 'mosaic', prefix: 'M' },
    { code: 'everbright', prefix: 'EvB' },
    { code: 'tribeam', prefix: 'T' },
    { code: 'medallion', prefix: 'T' },
  ],

  AUTOPAY_STATUSES: {
    VERIFIED: 'verified',
    ENROLLED: 'enrolled',
    UNENROLLED: 'unenrolled',
    STARTED: 'started',
  },

  CASH_CUSTOMER_PII: {
    ssn: '666666666',
    dob: '06/06/1666',
    income: 25000,
  },
};

export default constants;
